import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {AfterViewInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { UserService } from 'src/app/service/user.service';
import { UtilityService } from 'src/app/service/utility.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';

export interface UserData {
  id: string;
  name: string;
  email: string;
}

const userData : UserData[] = [
  {
    id : '1',
    name : 'Shankar',
    email : 'shankar@aithent.com'
  },
  {
    id : '2',
    name : 'Lavanya',
    email : 'lavanya@aithent.com'
  },
  {
    id : '3',
    name : 'Rajesh',
    email : 'rajesh@aithent.com'
  },
  {
    id : '4',
    name : 'Ajith',
    email : 'ajith@aithent.com'
  }
]

@Component({
  selector: 'app-activate-user-view',
  templateUrl: './activate-user-view.component.html',
  styleUrls: ['./activate-user-view.component.css']
})
export class ActivateUserViewComponent implements OnInit, OnChanges{
  displayedColumns: string[] = ['name', 'email', 'activate', 'reject'];
  dataSource: MatTableDataSource<UserData> = new MatTableDataSource<UserData>([]);
  selection = new SelectionModel<UserData>(true, []);
  rejectSelection = new SelectionModel<UserData>(true, [])
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  reqJson:any ={};
  selectedMail: any='';
  rejectedMail: any='';
  selectedMailStr: any='';
  userList : any =[];
  temp : any;
  rejectedMailStr: any='';
  constructor(private userService : UserService,private spinner: NgxSpinnerService,private utilService : UtilityService,private notifier:NotifierService) { 

  }
  ngOnChanges(changes: SimpleChanges): void {

 
  }

  ngOnInit(): void {
    this.spinner.show();
    this.userService.userDetailsForCompany(localStorage.orgCode).subscribe((data: any) => {
      this.dataSource.data = data.body;
      this.spinner.hide();
    });
  }

  /** Builds and returns a new User. */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelectedReject() {
    const numSelected = this.rejectSelection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggleReject() {
    this.isAllSelectedReject() ?
        this.rejectSelection.clear() :
        this.dataSource.data.forEach(row => this.rejectSelection.select(row));
  }

  selectActivate(row:any,event:any, index : any){
 
    
    var userListJson={
      "userId":row.userId,
      "isActive":row.isActive,
      "email":row.email,
      "firstName":row.firstName,
      "lastName":row.lastName,
      "orgCode":row.orgCode,
      "phno":row.phno,
      "loginName":row.loginName,
      "isActiveVal":true
    }
    let rejectId = <HTMLElement>document.getElementById('reject-check_'+index+'-input');

    if(event.checked == true){
      // reject-check_0-input
      rejectId.setAttribute('disabled','true')
      this.selectedMailStr += row.email+",";
      // this.selectedMailStr = this.utilService.removeLastString(this.selectedMailStr, ",");
      this.userList.push(userListJson)
    }else if(event.checked == false){
      rejectId.removeAttribute('disabled')
      // this.selectedMailStr = this.utilService.removeLastString(this.selectedMailStr, row.email+",");
     this.selectedMailStr = this.selectedMailStr.replace(row.email+",", "")
      // this.selectedMailStr = this.utilService.removeLastString(this.selectedMailStr, ",");
      this.userList.pop(userListJson)
    }
   }

   selectReject(row:any,event:any, index : any){
    var userListJson={
      "userId":row.userId,
      "isActive":row.isActive,
      "email":row.email,
      "firstName":row.firstName,
      "lastName":row.lastName,
      "orgCode":row.orgCode,
      "phno":row.phno,
      "loginName":row.loginName,
      "rejectVal":true
    }
    let rejectId = <HTMLElement>document.getElementById('activate-check_'+index+'-input');
    if(event.checked == true){
      rejectId.setAttribute('disabled','true')
      this.rejectedMailStr += row.email+",";
      this.userList.push(userListJson)
    }else if(event.checked == false){
      this.rejectedMailStr  = this.rejectedMailStr.replace(row.email+",","")
      rejectId.removeAttribute('disabled')
      this.userList.pop(userListJson);
    }
   }

   saveActiveUser(){
    this.spinner.show();
    if(this.selectedMailStr != ""){
      this.selectedMailStr = this.selectedMailStr.substring(0,this.selectedMailStr.length-1)
    } 
    if(this.rejectedMailStr != ""){
      this.rejectedMailStr = this.rejectedMailStr.substring(0,this.rejectedMailStr.length-1)
    } 
     this.reqJson={
       "tempArray" : this.selectedMailStr,
       "rejectArray":this.rejectedMailStr,
       "adminEmail": localStorage.email,
       "orgCode": localStorage.orgCode,
       "userList":this.userList
     }


     if(this.reqJson.tempArray != "" || this.reqJson.rejectArray != ""){
      this.userService.updateForActiveUser(this.reqJson).subscribe((data: any) => {
   
    
        this.userService.userDetailsForCompany(localStorage.orgCode).subscribe((data: any) => {
          this.dataSource = new MatTableDataSource(data.body);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.selectedMailStr = "";
          this.rejectedMailStr = "";
          this.spinner.hide();
          this.notifier.show({
            type: 'success',
            message: 'Data saved successfully'
          });
        });
      });
      
    } else {
      this.spinner.hide();
      this.notifier.show({
        type: 'error',
        message: 'Data Not saved please select the values' 
      });
    }
    
   }
}
